import "./styles.css";
import "@noones/ui/styles.css";
import "@noones/ui/dist/style.css";

import { createRoot } from "react-dom/client";
import React from "react";
import { Provider } from "react-redux";
import { App } from "./App";
import { ThemeProvider } from "@noones/ui";
import { store } from "../store";
import { IntlProviderWrapper } from "@modules/i18n/ui/IntlProviderWrapper";

const root = document.getElementById("root");

if (!root) {
    throw new Error("Root element is not found");
}

createRoot(root).render(
    <Provider store={store}>
        <ThemeProvider theme="light">
            <IntlProviderWrapper>
                <App />
            </IntlProviderWrapper>
        </ThemeProvider>
    </Provider>,
);
